import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full border-t-2 px-8 py-3 lg:flex justify-between items-center" }
const _hoisted_2 = { class: "mb-2 lg:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "mr-6 hover:text-gray-900"
  }, "Terms of Service"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "mr-6 hover:text-gray-900"
  }, "Privacy Policy"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "hover:text-gray-900"
  }, "About Us")
], -1)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentYear = ref<number>(new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "© Copyright " + _toDisplayString(currentYear.value), 1),
    _hoisted_3
  ]))
}
}

})